"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const pinia_1 = require("pinia");
const vue_2 = require("swiper/vue");
const App_vue_1 = __importDefault(require("./App.vue"));
const AlertList_vue_1 = __importDefault(require("./components/alerts/AlertList.vue"));
const AlertTester_vue_1 = __importDefault(require("./components/alerts/AlertTester.vue"));
const BasketNavIcon_vue_1 = __importDefault(require("./components/basket/BasketNavIcon.vue"));
const BasketShow_vue_1 = __importDefault(require("./components/basket/BasketShow.vue"));
const BlogIndex_vue_1 = __importDefault(require("./enso/blog/components/BlogIndex.vue"));
const BlogPostPreview_vue_1 = __importDefault(require("./enso/blog/components/BlogPostPreview.vue"));
const ButtonIcon_vue_1 = __importDefault(require("./components/ButtonIcon.vue"));
const CookieNotice_vue_1 = __importDefault(require("./components/CookieNotice.vue"));
const EnquiryButton_vue_1 = __importDefault(require("./components/enquiries/EnquiryButton.vue"));
const ListingDetails_vue_1 = __importDefault(require("./components/listings/ListingDetails.vue"));
const ListingExtraItem_vue_1 = __importDefault(require("./components/listings/ListingExtraItem.vue"));
const ListingsIndex_vue_1 = __importDefault(require("./components/listings/ListingsIndex.vue"));
const GoogleMap_vue_1 = __importDefault(require("./components/GoogleMap.vue"));
const MainMenu_vue_1 = __importDefault(require("./components/MainMenu.vue"));
const NewsletterForm_vue_1 = __importDefault(require("./components/NewsletterForm.vue"));
const ProficiencyTest_vue_1 = __importDefault(require("./components/proficiency-test/ProficiencyTest.vue"));
const Revealer_vue_1 = __importDefault(require("./components/Revealer.vue"));
const SvgSprite_vue_1 = __importDefault(require("./components/SvgSprite.vue"));
const SimpleCarousel_vue_1 = __importDefault(require("./components/SimpleCarousel.vue"));
const BespokeListingsList_vue_1 = __importDefault(require("./components/listings/BespokeListingsList.vue"));
const pinia = (0, pinia_1.createPinia)();
const app = (0, vue_1.createApp)(App_vue_1.default);
app.component('alert-list', AlertList_vue_1.default);
app.component('alert-tester', AlertTester_vue_1.default);
app.component('basket-nav-icon', BasketNavIcon_vue_1.default);
app.component('basket-show', BasketShow_vue_1.default);
app.component('button-icon', ButtonIcon_vue_1.default);
app.component('blog-index', BlogIndex_vue_1.default);
app.component('blog-post-preview', BlogPostPreview_vue_1.default);
app.component('cookie-notice', CookieNotice_vue_1.default);
app.component('enquiry-button', EnquiryButton_vue_1.default);
app.component('google-map', GoogleMap_vue_1.default);
app.component('listing-details', ListingDetails_vue_1.default);
app.component('listing-extra-item', ListingExtraItem_vue_1.default);
app.component('listings-index', ListingsIndex_vue_1.default);
app.component('main-menu', MainMenu_vue_1.default);
app.component('newsletter-form', NewsletterForm_vue_1.default);
app.component('proficiency-test', ProficiencyTest_vue_1.default);
app.component('v-revealer', Revealer_vue_1.default);
app.component('swiper-slide', vue_2.SwiperSlide);
app.component('simple-carousel', SimpleCarousel_vue_1.default);
app.component('svg-sprite', SvgSprite_vue_1.default);
app.component('bespoke-listings', BespokeListingsList_vue_1.default);
app.use(pinia);
app.mount('#app');
